import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import isEmpty from 'lodash/isEmpty';

import { NOT_SELECTED_CREDIT_CARD_TYPE } from '~/common/utils/errorMessaging';
import Button from '../CommonButton';
// Import Local Styles
import styles from './CreditCardTypeModal.css';

@inject('flexFrameStore', 'formsStore')
@observer
export default class LoginModal extends Component {
    state = {
        hasError: false
    }

    confirmSelection(ev) {
        ev.preventDefault();
        const { flexFrameStore, formsStore } = this.props;
        const { CreditCardTypeInfo } = formsStore;

        if (isEmpty(CreditCardTypeInfo)) {
            this.setState({ hasError: true });
            return;
        }

        flexFrameStore.setCardTypeInfo(
            CreditCardTypeInfo.cardType,
            CreditCardTypeInfo.codeLabel,
            CreditCardTypeInfo.codeLength
        );

        flexFrameStore.setDifferentValidCardTypesDetected(false);
    }
    setSelectedCardType(cardType) {
        const { formsStore } = this.props;

        this.setState({ hasError: false });
        formsStore.setCreditCardTypeInfo(cardType);
    }
    render() {
        const { CreditCardTypeInfo } = this.props.formsStore;
        const { validCardTypesDetected } = this.props.flexFrameStore;

        return (
            <div className={styles.wrapper} id="trial__login-modal">
                <h3 className={styles.header}>Select your credit card type</h3>
                {this.state.hasError && <p className={styles['error-message']}>{NOT_SELECTED_CREDIT_CARD_TYPE}</p>}
                <form className={styles.form}>
                    {
                        validCardTypesDetected.map((cardTypeInfo) => {
                            return (
                                <div
                                    className={styles['radio-container']}
                                    key={cardTypeInfo.cardType}
                                >
                                    <input
                                        checked={CreditCardTypeInfo.cardType === cardTypeInfo.cardType}
                                        data-test={`card_${cardTypeInfo.cardType}`}
                                        id={`card_${cardTypeInfo.cardType}`}
                                        name="CardType"
                                        onChange={() => { this.setSelectedCardType({ ...cardTypeInfo }); } }
                                        type="radio"
                                    />
                                    <label
                                        className={styles.label}
                                        htmlFor={`card_${cardTypeInfo.cardType}`}
                                    >{cardTypeInfo.cardName}</label>
                                </div>
                            );
                        })
                    }
                    <Button
                        modifier={styles.button}
                        onClick={ev => this.confirmSelection(ev)}
                    >
                        Confirm
                    </Button>
                </form>
            </div>
        );
    }
}
